import { render, staticRenderFns } from "./ProfileForm.vue?vue&type=template&id=9cab7c6a"
import script from "./ProfileForm.vue?vue&type=script&lang=ts"
export * from "./ProfileForm.vue?vue&type=script&lang=ts"
import style0 from "./ProfileForm.vue?vue&type=style&index=0&id=9cab7c6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports